import { jsx as n } from "./_virtual/jsx-runtime.js";
const m = (param)=>/* @__PURE__ */ {
    let { left: i , right: o , children: t  } = param;
    return n("div", {
        style: {
            marginLeft: i || !i && !o ? -16 : void 0,
            marginRight: o || !i && !o ? -16 : void 0
        },
        children: t
    });
};
export { m as default };
